import React from 'react';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import testIds from '@smart-tv/e2e/shared/variables';

import Button from '@smart-tv/components/button/button';
import Typography from '@smart-tv/components/typography';

import PlayerDevicesContext from '../player-devices-context';
import styles from './player-devices-dialog.module.scss';

export const PlayerDevicesDialogHomeScreen: React.FC = () => {
  const { texts, handleEditDevices, handleClose } = React.useContext(PlayerDevicesContext);

  const { ref, focusSelf, focusKey } = useFocusable({ isFocusBoundary: true });

  React.useEffect(() => {
    focusSelf();
  }, [focusSelf]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div
        ref={ref}
        className={styles['player-devices-dialog-home-screen']}
        data-testid={testIds.player.tv2Dialog.dialog}
      >
        <Typography
          variant="h3"
          className={styles['player-devices-dialog-home-screen__header']}
        >
          {texts?.headline}
        </Typography>
        <Typography
          variant="h6"
          className={styles['player-devices-dialog-home-screen__text1']}
        >
          {texts?.body1}
        </Typography>
        <Typography className={styles['player-devices-dialog-home-screen__text2']}>
          {texts?.body2}
        </Typography>
        <Button
          onClick={handleEditDevices}
          className={styles['player-devices-dialog-home-screen__button']}
          data-testid={testIds.player.tv2Dialog.administerButton}
        >
          Administrér enheder
        </Button>
        <Button
          onClick={handleClose}
          className={styles['player-devices-dialog-home-screen__button']}
          data-testid={testIds.player.tv2Dialog.goBackButton}
        >
          Gå tilbage
        </Button>
      </div>
    </FocusContext.Provider>
  );
};

export default PlayerDevicesDialogHomeScreen;
